import { useEffect, useRef } from "react";
import { useRefreshTokenMutation } from "features/auth/auth";
import { useAppSelector } from "features/store";

/** Refresh access token every 25 min (token lifetime is 30 min) to avoid 401 during long sessions. */
const REFRESH_INTERVAL_MS = 25 * 60 * 1000;

export function useTokenRefresh() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const [refreshToken] = useRefreshTokenMutation();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    const doRefresh = () => {
      refreshToken().catch(() => {
        // 401 will be handled by baseQueryWithReauth (logout + toast)
      });
    };

    intervalRef.current = setInterval(doRefresh, REFRESH_INTERVAL_MS);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isAuthenticated, refreshToken]);
}
